import { RouteObject } from 'react-router-dom'

import AccessManageMain from 'routes/Dashboard/routes/AccessManage/routes/AccessManageMain'
import AddUser from 'routes/Dashboard/routes/AccessManage/routes/Create'
import EditUser from 'routes/Dashboard/routes/AccessManage/routes/Edit'
import AccessManageUser from 'routes/Dashboard/routes/AccessManage/routes/[user]'

import AccessManageWrapper from './ui/AccessManageWrapper'

export const accessManageRoutes: RouteObject[] = [
  {
    path: 'access-manage',
    element: <AccessManageWrapper />,
    children: [
      {
        path: '',
        element: <AccessManageMain />,
      },
      {
        path: ':userId',
        element: <AccessManageUser />,
      },
    ],
  },
  {
    path: 'access-manage/add-user',
    element: <AddUser />,
  },
  {
    path: 'access-manage/:userId/edit-user',
    element: <EditUser />,
  },
]
